<template>
  <div class="parkApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" :element-loading-text="tsmsg" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <headComponent></headComponent>
    <div style="height:36px"></div>
    <swiper :options="swiperOption">
      <swiper-slide class="swiper-slide games" v-for="(item,i) in setMakeDetail.img">
        <a href=""><img :src="baseUrl+item"></a>
      </swiper-slide>
    </swiper>
    <div class="cont">
      <div class="info">
        <h2 class="title">{{setMakeDetail.title}}</h2>
        <h2>景区地址：{{setMakeDetail.address}}</h2>
        <h2 style="padding-top:10px">
          <p>联系客服：18580092850</p>
          <p>营业时间：周一至周日 {{setMakeDetail.business}}</p>
          <p style="color:red;padding-bottom:15px">预约时间：{{setMakeDetail.starttime}} ~ {{setMakeDetail.endtime}}</p>
        </h2>
        <h2 class="box" @click="drawer = true">请选择游卡套餐
          <div class="right"><font>{{choose == -1 ? '请选择游卡套餐' : setPayCard[choose].title}}</font><i class="el-icon-arrow-right"></i></div>
        </h2>
      </div>
    </div> 
    <div class="footer1">
      <div class="foot-title" @click="drawer = true">
        <span>{{choose == -1 ? '请选择游卡套餐' : setPayCard[choose].title}}</span>
        <font v-if="choose == -1">去选择<i class="el-icon-arrow-right"></i></font>
        <font v-if="choose != -1">选择 1 次</font>
      </div>
      <div class="pay">
        <span v-if="choose != -1" @click="saveGather">确认预约</span> 
        <span v-if="choose == -1" style="background:#ccc">请选择游卡套餐</span>        
      </div>
    </div>



    <el-drawer title="请选择游卡套餐" :visible.sync="drawer" :direction="direction" size="65%" :withHeader="true" :show-close="false" :wrapperClosable="false">
      <ul>
        <li v-for="(item,i) in setPayCard" @click="chooseCard(i)">
          <div :class="active == item.id ? 'chooseInfo curt':'chooseInfo'">
            <font v-if="item.status == 1 && item.surplus > 0" :class="active == item.id ? 'el-icon-success':''"></font>
          </div>
          <div class="cardCon">
            <h2>{{item.title}}</h2>
            <p>订单号：{{item.number}}</p>
            <p>有效时间：{{item.starttime}} ~ {{item.endtime}}</p>
            <p>
              <font>门票总数:<b>{{item.total}}</b>张</font>
              <font>已使用:<b>{{item.useTotal}}</b>张</font>
              <font>剩余:<b>{{item.surplus}}</b>张</font>
            </p>
          </div>
          <div class="status" :style="item.status == 1 ? '' : 'color:red'">{{item.status == 1 ? (item.surplus <=0 ? '已用完' : '有效中') : '已过期'}}</div>
        </li>
      </ul>
      <div class="yesBtn">
        <i class="el-icon-close" @click="drawer = false;choose=-1;active=''"></i>
        <a v-if="active !=''" @click="drawer=false">确定</a>
      </div>
    </el-drawer>
  </div>
</template>
<script>
  import $ from 'jquery'
  export default {
    data() {
      return {
        drawer:false,
        direction: 'btt',
        curHeight:0,
        fullscreenLoading: false,

        swiperOption: {
          autoplay : {
            disableOnInteraction: false, //用户操作后是否禁止自动循环
            delay: 1000 //自自动循环时间
          }, //可选选项，自动滑动
          initialSlide: 0,
          speed: 1000, //切换速度，即slider自动滑动开始到结束的时间（单位ms）
          loop:false, //循环切换
          grabCursor: true, //设置为true时，鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状
          autoHeight: true,   //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化。   
          scrollbar: '.swiper-scrollbar',
          mousewheelControl: true, //设置为true时，能使用鼠标滚轮控制slide滑动
          observeParents: true, //当改变swiper的样式（例如隐藏/显示）或者修改swiper的子元素时，自动初始化swiper
       
          pagination: {
            el: '.swiper-pagination',
            clickable :true, //点击分页器的指示点分页器会控制Swiper切换
          },     
        },
        userData:[],
        tsmsg:'数据加载中',
        setMakeDetail:[],
        setPayCard:[],
        active:'',
        choose:-1
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var id = this.$route.query.id;
          var url = encodeURIComponent('http://user.4008005216.com/main/gathermake?id='+id);
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
        }
      }else{
        this.userData = JSON.parse(localStorage.getItem('userjwt'));
      }
    },
    mounted() {
      this.beforeMount();
      if(localStorage.getItem('userjwt') == null){
        this.login();
      }else{
        this.getMakeDetail();
      }
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      getMakeDetail:function(){
        var that = this;
        that.fullscreenLoading = true;
        var id = that.$route.query.id;
        $.ajax({
          type:'post',
          url:that.$host+'home/gather/getMakeDetail',
          dataType:'json',
          data:{
            id:id
          },
          success:function(data){
            if(data.status == 200){
              that.setMakeDetail = data.data;
              that.getPayCard(data.data.scenic_id)
            }else{
              that.$alert(data.message,'提示');
            }
            that.fullscreenLoading = false;
          }
        })
      },
      getPayCard:function(id){
        var that = this;
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/gather/payCard',
          dataType:'json',
          data:{
            user_id:that.userData.id,
            s_id:id
          },
          success:function(data){
            if(data.status == 200){
              that.setPayCard = data.data;
            }else{
              that.$alert(data.message,'提示');
            }
            that.fullscreenLoading = false;
          }
        })
      },
      chooseCard:function(inx){
        if(this.setPayCard[inx].status <= 0 || this.setPayCard[inx].surplus <= 0){
          return false;
        }
        this.active = this.setPayCard[inx].id;
        this.choose = inx
      },
      saveGather:function(){
        var that = this;
        if(that.choose == -1){
          that.$alert('请选择游卡套餐!', '提示', {
            confirmButtonText: '确定'
          });
          return false;
        }
        that.$confirm('是否确认确认预约?', '温馨提醒', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          $.ajax({
            type:'post',
            url:that.$host+'home/gather/saveMake',
            data:{
              panId:that.active,
              user_id:that.userData.id,
              scenic_id:that.setMakeDetail.scenic_id
            },
            dataType:'json',
            success:function(data){
              if(data.status == 200){
                that.$router.go(-1)
              }else{
                that.$alert(data.message,'提示');
              }
              that.fullscreenLoading = false;
            }
          })
        }).catch(() => {
          that.fullscreenLoading = false;
        });
      },
      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          that.userData = res.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      }
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:80%
  }
  .parkApp{
    width:100%;
    background:#ececec;
    margin:0 auto;
  }
  .parkApp .swiper-slide{
    width:100%
  }
  .parkApp .swiper-slide img{
    display:block;
    width:100%;
  }
  .parkApp .cont{
    display:block;
    margin:0 auto;
    z-index:99;
    position:relative;
  }
  .parkApp .info{
    width:100%;
    display:block;
    position:relative;
    background:#fff;
  }
  .parkApp .info h2{
    font-size:15px;
    width:92%;
    display:block;
    margin:0 auto;
    font-weight:normal;
    color:#333;
  }
  .parkApp .info h2.title{
    color:#000;
    font-weight:bold;
    font-size:16px;
    padding:15px 0 12px 0
  }
  .parkApp .info h2 p{
    font-size:14px;
    color:#5d5d5d;
    padding-bottom:8px
  }
  .parkApp .info h2.box{
    border-top:solid 1px #f5f5f5;
    padding:18px 0;
    color:#666
  }
  .parkApp .info h2 .right{
    float:right;
    width:60%;
    text-align:right
  }
  .parkApp .info h2 .right font{
    color:#ff5555;
    float:left;
    width:90%;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .parkApp .info h2 .right i{
    float:right;
    margin-top:3px
  }

  .parkApp .footer1{
    height: 60px;
    background: #fff;
    width: 100%;
    position: fixed;
    bottom: 0px;
    left: 0;
    z-index: 99
  }
  .parkApp .footer1 .foot-title{
    float: left;
    margin-left: 3%;
    height:60px;
    width:52%;
  }
  .parkApp .footer1 .foot-title span{
    font-size: 14px;
    color: #6b6b6b;
    display:block;
    padding:10px 0 2px 0
  }
  .parkApp .footer1 .foot-title font{
    font-size: 14px;
    color: #f00;
    display:block;

  }
  .parkApp .footer1 .pay{
    float: right;
    color: #fff;
    margin-right: 3%;
    margin-top:10px;
    width:40%
  }
  .parkApp .footer1 .pay span{
    float:left;
    height:40px;
    line-height:40px;
    font-size: 14px;
    width:100%;
    text-align:center;
    font-weight:bold;
    background: #f00;
    border-radius:50px;
  }


  .parkApp .el-drawer__open .el-drawer.btt{
    border-radius:16px 16px 0 0;
  }
  .parkApp .el-drawer__header{
    margin:0 auto !important;
    padding:0 3%;
    height:50px;
    width:94%;
    position: absolute;
    top:0;
    left:0%;
    z-index:999;
    border-bottom:1px #f5f5f5 solid;
    background:#fff;
    text-align:center;
    color:#000
  }
  .parkApp .yesBtn{
    width:100%;
    position: absolute;
    top:0;
    left:0%;
    height:50px;
    z-index:9999;
  }
  .parkApp .yesBtn a{
    float:right;
    margin-right:4%;
    height:50px;
    line-height:50px;
    color:#0059D6;
    font-size:15px;
    letter-spacing:1px
  }
  .parkApp .yesBtn i{
    float:left;
    margin-left:4%;
    height:50px;
    line-height:50px;
    color:#000;
    font-size:18px
  }
  .parkApp .el-drawer__body ul{
    padding-top:65px;
  }
  .parkApp .el-drawer__body ul li{
    width:92%;
    margin:0 auto;
    border-bottom:solid 1px #f5f5f5;
    margin-bottom:15px;
    padding-bottom:15px;
  }
  .parkApp .el-drawer__body ul li:last-child{
    border-bottom:none;
    padding-bottom:0;
  }
  .parkApp .el-drawer__body ul li:after{
    content: '';
    height: 0;
    line-height: 0;
    display: block;
    visibility: hidden;
    clear: both;
  }
  .parkApp .el-drawer__body ul li .chooseInfo{
    float:left;
    width:20px;
    height:20px;
    margin-top:33px;
    margin-right:4%
  }
  .parkApp .el-drawer__body ul li .chooseInfo font{
    display:block;
    width:20px;
    height:20px;
    border:solid #000000 1px;
    border-radius:50%;
    line-height:20px;
    color:#000
  }
  .parkApp .el-drawer__body ul li .curt font{
    border:none;
    font-size:23px;
  }
  .parkApp .el-drawer__body ul li .cardCon{
    float:left;
    width:75%
  }
  .parkApp .el-drawer__body ul li .cardCon h2{
    font-size:15px;
    letter-spacing:1px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .parkApp .el-drawer__body ul li .cardCon p{
    font-size:12px;
    color:#666;
    padding-top:6px
  }
  .parkApp .el-drawer__body ul li .cardCon p font{
    padding-right:10px;
  }
  .parkApp .el-drawer__body ul li .cardCon p font b{
    color:#0059D6;
    padding-right:1px
  }
  .parkApp .el-drawer__body ul li .status{
    float:right;
    font-size:13px;
    color:#333;
    line-height:66px
  }
</style>